import React from "react";

import { Subscribe } from "unstated";

import { ProfileContainer } from "./containers/profile-container";

import { AddressUpdate } from "./address-update";

const ConveyancePreferences = () => (
  <Subscribe to={[ProfileContainer]}>
    {(profileContainer) => {
      const shippingAddress = profileContainer.getShippingAddress();

      return (
        <div className="container p-2">
          <div className="row d-flex">
            <div className="col-sm-6">
              <AddressUpdate address={shippingAddress} />
            </div>
            <div className="col-sm-6" />
          </div>
        </div>
      );
    }}
  </Subscribe>
);

export { ConveyancePreferences };
